import { Modal } from "antd";

const acoesComDestaque = {
  ativar: "#389e0d",
  desbloquear: "#389e0d",
  marcar: "#389e0d",
  bloquear: "#cf1322",
  desativar: "#cf1322",
  desmarcar: "#cf1322",
};

const destacarAcao = (description) => {
  const partes = description.split(/(ativar|desativar|bloquear|desbloquear|marcar|desmarcar)/i);

  return partes.map((parte, index) => {
    const cor = acoesComDestaque[parte.toLowerCase()];

    return cor ? (
      <span key={index} style={{ color: cor, fontWeight: 700 }}>
        {parte}
      </span>
    ) : (
      parte
    );
  });
};

export const ModalControle = ({
  status,
  visible,
  onCancel,
  onConfirm,
  loading,
  title,
  description,
  primaryAction,
}) => (
  <Modal
    title={title}
    visible={visible}
    onCancel={onCancel}
    onOk={onConfirm}
    confirmLoading={loading}
  >
    <p style={{ margin: 0, fontSize: 16, fontWeight: 500 }}>
      {destacarAcao(description)}
    </p>
  </Modal>
);
